const gql = String.raw;

const journeysQueries = {
  fetchJourneyGroups: gql`
    query ($journeyGroupType: String!, $includeInactive: Boolean!) {
      journeyGroups(journeyGroupType: $journeyGroupType, includeInactive: $includeInactive) {
        id
        group_type
        name
      }
    }
  `,

  fetchStageGroup: gql`
    query ($type: Int!) {
      stage_group(type: $type) {
        id
        stages {
          id
          stage
          journeyId
        }
      }
    }
  `,

  fetchJourneys: gql`
    query ($journeyGroupId: BigInt!, $taskOwnerUserId: BigInt!, $taskStatuses: [String!], $selectedDate: Date!) {
      journeysForJourneyGroup(journeyGroupId: $journeyGroupId) {
        id
        name
        journey_type
        objective_description
        steps {
          id
          step_number
          day_number
          description
          task_template {
            title
          }
        }
        tasks_due_counts(taskOwnerUserId: $taskOwnerUserId, taskStatuses: $taskStatuses, selectedDate: $selectedDate)
      }
    }
  `,

  fetchJourneysForProfile: gql`
    query ($journeyGroupId: BigInt!) {
      journeysForJourneyGroup(journeyGroupId: $journeyGroupId) {
        id
        name
        journey_type
      }
    }
  `,

  fetchJourneysForReporting: gql`
    query ($ids: [BigInt!]) {
      journeys(ids: $ids) {
        id
        name
        journey_type
        objective_description
        steps {
          id
          step_number
          day_number
          description
          task_template {
            title
          }
        }
      }
    }
  `,

  fetchTask: gql`
    query ($journeyTaskId: Int!, $selectedDate: Date, $ownerUserId: Int!, $statuses: [String]) {
      tasksForJourney(
        journeyTaskId: $journeyTaskId
        selectedDate: $selectedDate
        ownerUserId: $ownerUserId
        statuses: $statuses
      ) {
        id
        title
        due_date
        completed_at
        action_type
        contact {
          profile_image {
            url
          }
          id
          contact_attributes {
            name_full
            year
          }
          constituencies {
            status
          }
          household_members {
            id
            contact_attributes {
              name_full
            }
            profile_image {
              url
            }
          }
          emails {
            email
            primary
          }
          phones {
            phone
            type
          }
          addresses {
            primary
            time_zone {
              time_zone
              zip_code
              observes_dst
              offset
            }
          }
        }
      }
    }
  `,

  fetchTaskCount: gql`
    query (
      $journeyTaskIds: [BigInt]
      $selectedDate: Date!
      $taskOwnerUserId: BigInt!
      $taskStatuses: [String!]
      $taskActionTypes: [String]
    ) {
      taskCount(
        journeyTaskIds: $journeyTaskIds
        selectedDate: $selectedDate
        taskOwnerUserId: $taskOwnerUserId
        taskStatuses: $taskStatuses
        taskActionTypes: $taskActionTypes
      )
    }
  `,

  fetchCompleteAndOverdueTasks: gql`
    query ($startDate: Date!, $endDate: Date!, $userId: BigInt!) {
      getCompletedAndOverdueTasks(startDate: $startDate, endDate: $endDate, userId: $userId) {
        id
        completed_at
        contact_journey_id
        due_date
        owner_user_id
        status
        target_contact_id
        title
        updated_at
        contact {
          profile_image {
            url
          }
          contact_attributes {
            name_full
          }
        }
        journey_name
      }
    }
  `,

  fetchContactJourneys: gql`
    query ($startDate: Date!, $endDate: Date, $userId: Int!) {
      contactJourneyByDate(startDate: $startDate, endDate: $endDate, userId: $userId) {
        contact_id
      }
    }
  `,

  // this exists elsewhere in the codebase
  fetchContacts: gql`
    query ($ids: [BigInt!]) {
      contacts(ids: $ids) {
        id
        contact_attributes {
          name_full
        }
      }
    }
  `,

  // recommended actions
  fetchAssignedWithRecentGiftContactIds: gql`
    query ($userSolicitorContactId: BigInt!, $daysSinceLastGift: Int!) {
      assignedWithRecentGiftContactIds(
        userSolicitorContactId: $userSolicitorContactId
        daysSinceLastGift: $daysSinceLastGift
      )
    }
  `,

  fetchContactForRecommendedAction: gql`
    query ($id: BigInt!) {
      contact(id: $id) {
        contact_attributes {
          name_full
        }
        profile_image {
          url
        }
        giving {
          lifetime_amount
          last_gift_date
          last_gift_amount
          last_gift_label
        }
        id
      }
    }
  `,
};

export default journeysQueries;
